<div class="login-page-footer">
  <div class="copyright">
    @switch (sessionFacade.branding$ | async) {
      @case (CustomBranding.sparkasse) {
        <ng-container *ngTemplateOutlet="brandedFooterTemplate"></ng-container>
      }
      @case (CustomBranding.enercity) {
        <ng-container *ngTemplateOutlet="brandedFooterTemplate"></ng-container>
      }
      @case (CustomBranding.komma) {
        <ng-container *ngTemplateOutlet="brandedFooterTemplate"></ng-container>
      }
      @default {
        {{ '© ' + ('GLOBAL.COPYRIGHT_VAYLENS' | translate: { year: getCurrentYear() }) }}
      }
    }
  </div>

  @if ((sessionFacade.branding$ | async) !== CustomBranding.none) {
    <div class="powered-by">
      <span>Powered by</span>
      <a href="https://vaylens.com" target="_blank" rel="noopener noreferrer">
        <img src="assets/img/logo/vaylens_full.svg" alt="Vaylens Logo" />
      </a>
    </div>
  }
</div>

<!-- Reusable template for branded footer content -->
<ng-template #brandedFooterTemplate>
  <img
    class="image"
    src="assets/img/logo/vaylens_small.svg"
    alt="Vaylens Logo"
    height="20"
    width="20" />
  <a href="{{ knowledgeBaseUrl }}" target="_blank" rel="noopener">{{
    'WIKI.KNOWLEDGE_BASE' | translate
  }}</a>

  <span class="vertical-divider" aria-hidden="true"></span>

  <a href="https://status.vaylens.com" target="_blank" rel="noopener noreferrer">
    {{ 'SYSTEM_STATUS.TITLE' | translate }}
  </a>
</ng-template>
